export default "__VITE_ASSET__DXZLxUTj__"